/**
 * Collection sort option "in-stock".
 * Shopify cannot sort by availability, so when that option is selected
 * we load every page of the current collection (filters included),
 * put available products first, and keep the existing load-more window.
 */
(() => {
  if (window.__mcfInStockSort) return;
  window.__mcfInStockSort = true;

  let requestToken = 0;

  function isActive() {
    const select = document.querySelector('#SortBydesktop');
    return !!select && select.value === 'in-stock';
  }

  function translations() {
    try {
      return JSON.parse(document.getElementById('wetheme-global').textContent).translations || {};
    } catch (e) {
      return {};
    }
  }

  function stockRank(item) {
    const card = item.querySelector('[data-product-available]');
    if (!card) return 0;
    return card.getAttribute('data-product-available') === 'true' ? 0 : 1;
  }

  function reinitCards() {
    if (typeof window.reinitialiseRatingSnippet === 'function') {
      window.reinitialiseRatingSnippet();
    }
  }

  async function fetchAllItems(sectionId) {
    const start = new URL(window.location.href);
    start.searchParams.delete('page');
    start.searchParams.set('section_id', sectionId);

    const items = [];
    const seen = new Set();
    let url = start.toString();

    while (url && !seen.has(url) && seen.size < 40) {
      seen.add(url);
      const response = await fetch(url);
      if (!response.ok) throw new Error('Collection page failed to load');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      doc.querySelectorAll('#template--collection > .grid__item').forEach((el) => {
        if (el.querySelector('[data-product-available]')) items.push(el);
      });
      const next = doc.querySelector('.pagination .pagination-next a')?.getAttribute('href');
      if (!next) break;
      const nextUrl = new URL(next, window.location.origin);
      nextUrl.searchParams.set('section_id', sectionId);
      url = nextUrl.toString();
    }

    return items;
  }

  function paintLoadMore(pagination, shown, total) {
    const copy = translations();
    const viewed = Math.min(shown, total);
    const progressText = (copy.youve_viewed || "You've viewed {{ x }} of {{ y }}")
      .replace('{{ x }}', String(viewed))
      .replace('{{ y }}', String(total));
    const percent = total ? (100 * viewed) / total : 100;

    pagination.classList.add('pagination--load-more');
    pagination.innerHTML = '';

    if (viewed >= total) return;

    const wrap = document.createElement('div');
    wrap.className = 'pagination__load-more';
    wrap.innerHTML = `
      <p class="pagination__progress-text"></p>
      <div class="progress-bar"><div class="progress-bar__inner" style="width:${percent}%;"></div></div>
      <button type="button" class="btn btn--load-more">
        <span class="btn--load-more--text"></span>
      </button>
    `;
    wrap.querySelector('.pagination__progress-text').textContent = progressText;
    wrap.querySelector('.btn--load-more--text').textContent = copy.load_more || 'Load more';
    pagination.appendChild(wrap);
  }

  async function apply() {
    if (!isActive()) return;

    const grid = document.getElementById('template--collection');
    const section = document.getElementById('CollectionProductGrid');
    if (!grid || !section) return;
    if (grid.dataset.instockSorted === 'true') return;

    const sectionId = section.dataset.sectionId;
    if (!sectionId) return;

    const token = ++requestToken;
    grid.dataset.instockSorting = 'true';
    grid.classList.add('is-instock-sorting');

    try {
      const items = await fetchAllItems(sectionId);
      if (token !== requestToken) return;
      if (!items.length) return;

      items.forEach((el, index) => {
        el._instockIndex = index;
      });
      items.sort((a, b) => stockRank(a) - stockRank(b) || a._instockIndex - b._instockIndex);

      const pagination = section.querySelector('.pagination');
      const pageSize = parseInt(pagination?.dataset.paginateSize || String(items.length), 10) || items.length;
      let shown = pageSize;

      items.forEach((el, index) => {
        el.classList.toggle('is-instock-hidden', index >= shown);
      });
      grid.replaceChildren(...items);

      if (pagination) {
        paintLoadMore(pagination, shown, items.length);
        if (!pagination.dataset.instockBound) {
          pagination.dataset.instockBound = 'true';
          pagination.addEventListener('click', (event) => {
            if (!event.target.closest('.btn--load-more')) return;
            event.preventDefault();
            event.stopPropagation();
            shown = Math.min(items.length, shown + pageSize);
            items.forEach((el, index) => {
              el.classList.toggle('is-instock-hidden', index >= shown);
            });
            paintLoadMore(pagination, shown, items.length);
            reinitCards();
          });
        }
      }

      grid.dataset.instockSorted = 'true';
      reinitCards();

      document.documentElement.dataset.instockApplying = 'true';
      document.dispatchEvent(new CustomEvent('paginate'));
    } catch (error) {
      console.error(error);
    } finally {
      if (token === requestToken) {
        document.documentElement.dataset.instockApplying = 'false';
        grid.classList.remove('is-instock-sorting');
        delete grid.dataset.instockSorting;
      }
    }
  }

  function onPaginate() {
    if (document.documentElement.dataset.instockApplying === 'true') return;
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  document.addEventListener('paginate', onPaginate);
})();
